// src/contexts/SucursalContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { useUser } from "../contexts/UserContext";
import Swal from "sweetalert2";

const SucursalContext = createContext();

export const useSucursal = () => useContext(SucursalContext);

export const SucursalProvider = ({ children }) => {
  const server = process.env.REACT_APP_API_ROUTE;

  // ✅ CAMBIO: rehidratar sucursal desde localStorage
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState(() => {
    const saved = localStorage.getItem("sucursalSeleccionada");
    return saved ? JSON.parse(saved) : null;
  });

  const { user } = useUser();

  const [cajaAbierta, setCajaAbierta] = useState(false);
  const [cajaAbiertaDatos, setCajaAbiertaDatos] = useState(null);
  const [requiereConteo, setRequiereConteo] = useState(false);

  // ✅ CAMBIO: persistir sucursal al cambiar
  useEffect(() => {
    if (sucursalSeleccionada) {
      localStorage.setItem("sucursalSeleccionada", JSON.stringify(sucursalSeleccionada));
    }
  }, [sucursalSeleccionada]);

  const verificarAperturaCaja = async () => {
    try {
      if (!user?.codigoUsuario || !sucursalSeleccionada?.idSucursal) {
        // ✅ CAMBIO: no spamear warnings, es normal en arranque
        return;
      }

      const username = `${user.codigoUsuario}/`;
      const response = await fetch(
        `${server}/MgCajaEncabezadoArqueos/porsucursalusuario/${sucursalSeleccionada.idSucursal}/${username}`
      );

      if (response.status === 404) {
        setCajaAbierta(false);
        setCajaAbiertaDatos(null);
        setRequiereConteo(false);
        return;
      }

      if (response.ok) {
        const data = await response.json();
        setCajaAbiertaDatos(data?.id ?? null);
console.log(data);
        if (!data || Object.keys(data).length === 0) {
          setCajaAbierta(false);
          setRequiereConteo(false);
        } else {
          const fechaCierre = new Date(data.fechahoracierre);
          const cajaNoHaSidoCerrada = fechaCierre.getFullYear() <= 1;
          if (cajaNoHaSidoCerrada) {
            setCajaAbierta(true);
            await verificarConteoExistente(data.id);
          } else {
            setCajaAbierta(false);
            setRequiereConteo(false);
          }
        }
      } else {
        console.error("Error al verificar apertura de caja:", response.status, response.statusText);
      }
    } catch (error) {
      console.error("Error en la solicitud de apertura de caja:", error);
    }
  };

  const verificarConteoExistente = async (idCaja) => {
    try {
      const response = await fetch(`${server}/MgCajaDenominaciones/conteo-por-caja/${idCaja}`);

      if (response.ok) {
        await response.json();
        setRequiereConteo(false);
      } else {
        setRequiereConteo(false);
      }
    } catch (error) {
      console.error("Error al verificar conteo existente:", error);
      setRequiereConteo(false);
    }
  };

  const validarOperacionCritica = async (nombreOperacion = "esta operación") => {
    if (!cajaAbierta) {
      await Swal.fire({
        title: "Caja Cerrada",
        text: `Debe abrir la caja antes de realizar ${nombreOperacion}.`,
        icon: "warning",
        confirmButtonText: "Entendido",
      });
      return false;
    }
    return true;
  };

  const actualizarCajaAbierta = () => {
    verificarAperturaCaja();
  };

  // ✅ CAMBIO: solo un useEffect (quitamos el duplicado)
  useEffect(() => {
    if (sucursalSeleccionada?.idSucursal && user?.codigoUsuario) {
      verificarAperturaCaja();
    }
  }, [sucursalSeleccionada?.idSucursal, user?.codigoUsuario]);

  return (
    <SucursalContext.Provider
      value={{
        sucursalSeleccionada,
        setSucursalSeleccionada,
        cajaAbierta,
        cajaAbiertaDatos,
        requiereConteo,
        actualizarCajaAbierta,
        validarOperacionCritica,
        verificarConteoExistente,
      }}
    >
      {children}
    </SucursalContext.Provider>
  );
};